<template>
  <div>
    <p>Our client account bank details are:</p>
    <table border="1">
      <tr>
        <td colspan="2">
          <v-img :src="require(`@/assets/payment/lloydsBankSmall.jpg`)" alt="Lloyds logo" />
        </td>
      </tr>
      <tr>
        <th>Address</th>
        <td>Lloyds Bank 77-81 High Street Chelmsford Essex CM1 1DU</td>
      </tr>
      <tr>
        <th>Account Name</th>
        <td>Nigel Broadhead Mynard Solicitors Client Account</td>
      </tr>
      <tr>
        <th>Sort Code</th>
        <td>30-91-85</td>
      </tr>
      <tr>
        <th>Account No</th>
        <td>00402003</td>
      </tr>
    </table>
    <p>Please quote our reference as shown on our letters and ensure the money comes from your own account.</p>
  </div>
</template>

<script>
export default {
  name: "BankDetails",
  metaInfo() {
    return {
      title: "Bank details",
      titleTemplate: "%s - Payments - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  }
};
</script>